import { render, staticRenderFns } from "./technical-details.vue?vue&type=template&id=139199b6"
import script from "./technical-details.vue?vue&type=script&lang=js"
export * from "./technical-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports